import {
  NSP_TOUR,
  DASHBOARD_TOUR,
  CLIENT_TOUR,
  BASE_WEEK_TOUR,
  SINGLE_DAY_TOUR,
  SHOW_TOOLTIP,
  NOTIFICATIONS_TOUR,
} from "./types";

export const startNspTour = startTour => {
  return { type: NSP_TOUR, payload: startTour };
};

export const startDashboardTour = startTour => {
  return { type: DASHBOARD_TOUR, payload: startTour };
};

export const startClientTour = startTour => {
  return { type: CLIENT_TOUR, payload: startTour };
};

export const startBaseWeekTour = startTour => {
  return { type: BASE_WEEK_TOUR, payload: startTour };
};

export const startSingleDayTour = startTour => {
  return { type: SINGLE_DAY_TOUR, payload: startTour };
};

export const setShowTooltip = value => {
  return { type: SHOW_TOOLTIP, payload: value };
};

export const startNotificationsTour = startTour => {
  return { type: NOTIFICATIONS_TOUR, payload: startTour };
};
